<div class="mobile-header d-lg-none" [ngClass]="{ 'mobile-header-hub': isProfilePage }">
  <div class="mobile-header-left">
    <button type="button" class="mobile-header-back" (click)="goBack()" aria-label="Back">
      <span class="icon material-icons" aria-hidden="true">arrow_back_ios</span>
    </button>
    <span class="mobile-header-title">{{ titleKey | translate: { fgbdefault: titleDefault } }}</span>
  </div>
  <div class="mobile-header-right" *ngIf="isProfilePage">
    <div class="mobile-header-points" *ngIf="points$ | async as points">
      <span class="icon material-icons" aria-hidden="true">loyalty</span>
      <span>{{ points | number: '1.0-0' }}</span>
    </div>
    <button type="button" class="mobile-header-qr" (click)="openQrModal()" aria-label="Show QR code">
      <span class="icon material-icons" aria-hidden="true">qr_code</span>
    </button>
  </div>
  <div class="mobile-header-curve" aria-hidden="true"></div>
</div>

<ng-template #qrModal let-modal>
  <div class="mobile-header-qr-modal">
    <div class="mobile-header-qr-modal-box" *ngIf="barcode$ | async as barcode">
      <qrcode [qrdata]="barcode.Barcode" [width]="200" [errorCorrectionLevel]="'M'" [elementType]="'svg'"></qrcode>
    </div>
    <p class="mobile-header-qr-modal-caption">
      {{ 'account.identity.scan' | translate: { fgbdefault: 'Scan at any gate' } }}
    </p>
    <button type="button" class="btn-filled-primary" (click)="modal.close()">
      {{ 'modal.close' | translate }}
    </button>
  </div>
</ng-template>
